import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const AccountTabRedirect = ({ to }: { to: string }) => {
    const location = useLocation();
    return <Navigate to={{ pathname: to, hash: location.hash }} replace />;
};
